import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsAddElementsScormEdit } from '@/learnpaths/components/LearnpathsAddElementsScormEdit/LearnpathsAddElementsScormEdit'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(scorm)/update/scorm/$elementId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  return <LearnpathsAddElementsScormEdit {...params} />
}
